/* global Date */
export default () => {
  const now = Date.now();
  const nextDay = new Date(now + 24 * 60 * 60 * 1000);
  nextDay.setHours(0, 0, 0, 0);
  return nextDay.getTime() - now;
};
